import { Dialog } from "@headlessui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

export default function PdfPreviewModal({
  isOpen,
  previewModal,
  isPageSliding,
  pageSlideDirection,
  onClose,
  onPrevPage,
  onNextPage,
}) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-4xl rounded-2xl bg-white p-4 shadow-xl">
          <Dialog.Title className="text-lg font-bold text-gray-900">
            ePaper PDF Preview - {previewModal.editionName}
          </Dialog.Title>
          {previewModal.allPagesPdfPaths.length > 0 ? (
            <div className="mt-3 flex items-center justify-between rounded-xl border border-gray-200 bg-gray-50 px-3 py-2">
              <button
                type="button"
                className="inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-3 py-1 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                disabled={previewModal.currentPageIndex <= 0}
                onClick={onPrevPage}
              >
                <ChevronLeftIcon className="h-4 w-4" />
                Previous
              </button>
              <p className="text-sm font-semibold text-gray-700">
                Page {previewModal.currentPageIndex + 1} of {previewModal.allPagesPdfPaths.length}
              </p>
              <button
                type="button"
                className="inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-3 py-1 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                disabled={previewModal.currentPageIndex >= previewModal.allPagesPdfPaths.length - 1}
                onClick={onNextPage}
              >
                Next
                <ChevronRightIcon className="h-4 w-4" />
              </button>
            </div>
          ) : !previewModal.pdfPath && previewModal.previewUrl ? (
            <div className="mt-3 flex items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
              <p>No PDF file is available for this edition. Showing the ePaper page instead.</p>
              <a
                href={previewModal.previewUrl}
                target="_blank"
                rel="noreferrer"
                className="shrink-0 font-semibold text-cyan-700 hover:text-cyan-800"
              >
                Open in new tab
              </a>
            </div>
          ) : null}
          <div className="mt-3 h-[70vh] overflow-hidden rounded-xl border border-gray-200 bg-white">
            {previewModal.allPagesPdfPaths.length > 0 ? (
              <div
                className={`h-full w-full transform transition-all duration-300 ${
                  isPageSliding
                    ? pageSlideDirection === "next"
                      ? "-translate-x-6 opacity-40"
                      : "translate-x-6 opacity-40"
                    : "translate-x-0 opacity-100"
                }`}
              >
                <iframe
                  title={`PDF Preview ${previewModal.editionName}`}
                  src={previewModal.allPagesPdfPaths[previewModal.currentPageIndex]}
                  className="h-full w-full"
                />
              </div>
            ) : previewModal.pdfPath ? (
              <iframe
                title={`PDF Preview ${previewModal.editionName}`}
                src={previewModal.pdfPath}
                className="h-full w-full"
              />
            ) : previewModal.previewUrl ? (
              <iframe
                title={`ePaper Preview ${previewModal.editionName}`}
                src={previewModal.previewUrl}
                className="h-full w-full"
              />
            ) : previewModal.mapPreview ? (
              <img
                src={previewModal.mapPreview}
                alt={`${previewModal.editionName} preview`}
                className="h-full w-full object-contain"
              />
            ) : (
              <div className="flex h-full flex-col items-center justify-center gap-2 px-6 text-center text-sm text-gray-500">
                PDF URL is not available for this edition.
              </div>
            )}
          </div>
          <div className="mt-4 flex justify-end gap-2">
            <button
              type="button"
              className="rounded-xl bg-cyan-500 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-600"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
